<template>
  <div v-if="isOpen">
    <div class="share-guide" @click="close">
      <img :src="guideObj.image" :style="getItemStyle()" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'UiShareGuide',
  components: {
  },
  props: {
  },
  data () {
    return {
      isOpen: false,
      guideObj: {}
    }
  },
  computed: {
  },
  watch: {
    'isOpen': function () {
      if (!this.isOpen) {
        this.content = ''
      }
    }
  },
  methods: {
    close () {
      this.isOpen = false
    },
    clickShareGuide (obj) {
      this.$set(this, 'guideObj', obj)
      this.isOpen = true
    },
    getItemStyle () {
      var style = 'position: absolute;'
      style += this.guideObj.size_type + ': ' + this.guideObj.size_value + ';'
      style += this.guideObj.y_axis_type + ': ' + this.guideObj.y_axis_value + ';'
      style += this.guideObj.x_axis_type + ': ' + this.guideObj.x_axis_value + ';'
      style += 'z-index: 90;'
      return style
    }
  },
  mounted () {
  }
}
</script>
<style>
.share-guide { position: absolute; width: 100%; height: 100%; top: 0; left: 0; background-color: rgba(55,55,55,.7); z-index: 700; }

</style>



// WEBPACK FOOTER //
// src/components/ui/shareGuide.vue